import React from 'react';
import { CheckValue, GetGymId, sortData } from "../../services/CommonFunction";
import { equipment, activityType, activitySetup, booleanCondition, gender, privacy_settings, difficultyLevel, activityType1, staticVar, location } from "../../services/Constants";
import { OpenPopup, ErrorUI, VideoPopup, ClosePopup } from "../../components/UI/Modals/Modals";
import { isArray } from 'util';
import Images from '../../components/UI/Image/Image';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlayCircle, faCheck } from '@fortawesome/free-solid-svg-icons';
import { selectIcon } from '../../components/UI/selector';
import { DateWithFormatTable } from '../../components/ReusableComponents/Date/Date';
import { activityService } from '../../services/subscriberService';
import { getSingleActiveDetail, GetLocationsList } from '../../services/CallApi';
import SortIcon from '../../components/ReusableComponents/SortIcon/SortIcon';
import ToolTips from '../../components/ReusableComponents/ToolTips/ToolTips';

export const touched = (key, form, status='group') => {
    if(status === 'group') {
        form.get(key).markAsTouched({ emitEvent: true });
        form.markAsTouched({ emitEvent: true });
    } else {
        form.get(key).markAsTouched({ emitEvent: true });
        form.markAsTouched({ emitEvent: true });
    }
}

export const getEquipment = (el, status) => {
    if (el && el.length) {
        return equipment.filter(option => el.filter(res => res.isRequired === status).filter(res => res.name === option.name).length);
    }
    return [];
}

export const StaffSort = (data) => (
    data.filter( function( item, index, inputArray ) {
        return inputArray.indexOf(item) === index;
    })
)

export const getStaticData = (el, status,addNew = true) => {
    if(!CheckValue(el) || (isArray(el) && !el.length)) {
        return {};
    }
    let temp  = [];
    let text = typeof el === 'string' || typeof el === 'boolean' ? el : el[0];
    if(typeof text !== "string") {
        return text;
    }
    switch (status) {
        case 'type':
            temp = activityType.filter(res => res.value === text);
            break;
        case 'type1':
            temp = activityType1.filter(res => res.value === text);
            if(!temp.length && addNew) {
                temp.push({ icon:null, name: text, value: text, child:[] });
            }
            break;
        case 'setup':
            temp = activitySetup.filter(res => res.value === text);
            break;
        case 'boolean':
            temp = booleanCondition.filter(res => res.value === (typeof el === 'string' || typeof el === "boolean" ? el : el[0]));
            break;
        case 'gender':
            temp = gender.filter(res => res.value === text);
            break;
        case 'privacy_settings':
            temp = privacy_settings.filter(res => res.value === text);
            break;
        case 'difficulty_level':
            temp = difficultyLevel.filter(res => res.value === text);
            if(!temp.length && addNew) {
                temp.push({ icon:null, name: text, value: text });
            }
            break;
        default:
    }
    return temp.length ? temp[0] : {};
}

export const UserName = (props) => (
    <div className="name_type">
        <span className={`name ${props.class || ''}${props.clicked?' cursorPC':''}`} onClick={props.clicked}>{ props.title || props.name ||'--'}</span>
        {/* {props.showType && <span className="type">{ props.template?(props.template.activityType ||'--'):'--'}</span>} */}
        {props.showType ?<CategoryUI num={1} data={props.template.activityType} />:null}
        {props.videoStatus? 
            <span className="type">
                {props.status === 'both' || props.status === 'vod'?
                <ToolTips showTooltip={true} position="top" message={props.status === 'both'?'Recorded Live':'On-demand'} >
                    <Images class="class_status" src = {selectIcon('vod')} />
                </ToolTips>
                :null}
                {props.status === 'both' || props.status === 'live'?<Images class="class_status"  src = {selectIcon('live')} />:null}
            </span>
        :null}
        {props.showDate && <DateWithFormatTable date={props.date} format={props.format || 'ddd Do MMMM YYYY'}/>}
        {props.showLocation ? <LocationUI num={1} location={props.location} />:null}
        {/* {props.showDate && <span className="type">{props.date?moment(props.date).format(props.format):'- - -'}</span>} */}
    </div>
)

export const ClassVideo = ({showVideo, ...props}) => {
    const activityLogo = props.template.activityLogo || props.activityLogo;
    const isNotOndemandVideo = !CheckValue(props.playback_url) || props.ondemandVideoStatus;
    return (
        <div className="image_div">
            {/* {!isNotOndemandVideo? <Images src = {activityLogo.thumb} />:null} */}
            {!showVideo && CheckValue(props.privacy_settings) && props.privacy_settings !== staticVar.public? 
                <ToolTips showTooltip={true} position="top" message={props.privacy_settings === staticVar.schedulePasswordProtected?'Password Protected':'Member only'} >
                    <Images class="icon" src = {selectIcon(props.privacy_settings === staticVar.schedulePasswordProtected?'passwordLock':'publicLock')} />
                </ToolTips>
            :null}
            <div className={`video_list${isNotOndemandVideo && CheckValue(props.playback_url)?' disable':''}`} onClick={() => {
                if(!isNotOndemandVideo) {
                    OpenPopup(<VideoPopup title={props.title} id={props.id} src={activityLogo.thumb} download={props.download} videoSrc={props.playback_url} addVersion={true} />);
                }
            }}>
                <Images src = {activityLogo.thumb} />
                {CheckValue(props.playback_url)?<FontAwesomeIcon icon={ faPlayCircle } />:null}
            </div>
        </div>
    )
}

export const getSingleActiveData = (data) => {
    getSingleActiveDetail(data).then(res => {
        if (res.status) {
            activityService.sendActivityMessage({ list: res.list, status: 'dataUpdate' });
        } else {
            ClosePopup(true);
            ErrorUI(res.list);
        }
    })
}

export const FilterTitle = (props) => {
    const activeValue = props.dateStatus[props.titleType]
    const temp = props.option.length?props.option.map((el,index) => <li key={index} meta-id={props.titleType} className={`optionList${activeValue === el.value?" activeOption":''}`} onClick={() => activityService.sendActivityMessage({data:{[props.titleType]: el.value,id:'none'},type:props.titleType,status:'filter'})} >
            {el.name}
            {activeValue === el.value?<FontAwesomeIcon meta-id={props.titleType} icon = { faCheck } />:null}
        </li>):<li key="noData" meta-id={props.titleType} className="noDatas">NO Data</li>;
    const cond = props.dateStatus.id === props.titleType;
    return (
        <React.Fragment>
            {props.sortValue?<SortIcon ascDesc={props.sortValue} keys={props.sortStatus} ascDescClick={props.ascDescClick} />:null}
            <div meta-id={props.titleType} onClick={() => activityService.sendActivityMessage({data:{id:cond?'none':props.titleType},status:'filter'})} className={`filterTitle${cond?' activeTitle':''}`}>
                {props.titleName}
                <img meta-id={props.titleType} className="downIcon" src = {selectIcon('down')} alt="calesdar" />
                {cond?<div className="titleOption" meta-id={props.titleType}>
                    <ul meta-id={props.titleType}>
                        {temp}
                    </ul>
                </div>:null}
            </div>
            {/* {props.sortStatus?<SortIcon ascDesc={props.sortValue} keys={props.sortStatus} ascDescClick={props.ascDescClick} />:null} */}
        </React.Fragment>
    )
}

export const LocationList = () => {
    if(!location.list.length && !location.fetch) {
        location.fetch = true;
        const data = {
            limit: 100,
            offset: 0,
            'gym_id': GetGymId(),
            is_active: true
        }
        GetLocationsList(data).then(res => {
            if(res.status) {
                location.list = res.list.filter(el => !el.is_default_location && el.is_active).map(el => ({name: el.name, value: el[el.keyValue || 'id']})).sort(sortData);
            } else {
                ErrorUI(res.list,() => {
                    location.fetch = false;
                    LocationList();
                }, {close: () => location.fetch = true});
            }
        })
    }
    return location.list;
}

export const LocationUI = ({num,...props}) => {
    let temp = null;
    const location = [...props.location].sort(sortData);
    if(location.length > num) {
        temp ='<ul>'
        location.slice(num, location.length).forEach(el => {
            temp += `<li>${ typeof el === 'string'?el: el.name}</li>`;
        });
        temp +='</ul>'
    }
    const option = location.length?location.slice(0, num).map((el,index) => <div className='locationDiv' key={index}>
        <ToolTips overflow={true} showTooltip={true} position="top" message={typeof el === 'string'?el: el.name} className="locationSpan" >
            {typeof el === 'string'?el: el.name}
        </ToolTips>
        {index === (num - 1) && location.length > num?<ToolTips showTooltip={true} position="right" message={temp} >
            <span className="location_count">{`+${location.length - num}`}</span>
        </ToolTips>:null}
    </div>):'---';
    return <div className="locationUI">{option}</div>
}

export const CategoryUI = ({num,data,...props}) => {
    let temp = null;
    // const location = [...props.data].sort(sortData);
    if(data.length > num) {
        temp ='<ul>'
        data.slice(num, location.length).forEach(el => {
            temp += `<li>${ typeof el === 'string'?el: el.name}</li>`;
        });
        temp +='</ul>'
    }
    const option = data.length?data.slice(0, num).map((el,index) => <div className='locationDiv category_li' key={index}>
        <ToolTips overflow={true} showTooltip={true} position="top" message={typeof el === 'string'?el: el.name} className="locationSpan" styleClas="category_li" >
            {typeof el === 'string'?el: el.name}
        </ToolTips>
        {index === (num - 1) && data.length > num?<ToolTips showTooltip={true} position="right" message={temp} messageClass="messageClass" >
            <span className="location_count">{`+${data.length - num}`}</span>
        </ToolTips>:null}
    </div>):'---';
    return <div className="locationUI">{option}</div>
}


